export { default as stateToHTML } from './stateToHTML';


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-export-html/esm/main.js
// module id = 2157
// module chunks = 7